import React, { useRef, useEffect, useState } from "react";
import classes from "./ModalAddJourneys.module.scss";
import { Button, InputNumber, message } from "antd";
import { getCurrentUser, fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";
import { ADMIN_AUDIOFOCO_ADD_JOURNEY } from "../../../constants/api";

const primaryButtonStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 40,
    borderRadius: 9,
    background: "#0d6e7a",
    border: "none",
    fontSize: 14,
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#ffffff",
};

const handlePrimaryButtonMouseEnter = (e) => {
    e.currentTarget.style.background = "#12808e";
};

const handlePrimaryButtonMouseLeave = (e) => {
    e.currentTarget.style.background = "#0d6e7a";
};

const ModalAddJourneys = ({
    setShowModalAddJourney,
    onJourneyUpdated,
    companyUid,
    planPermission,
    currentUsersGo,
    currentUsersSmart,
}) => {
    const myRefName = useRef();
    let modalColor = null;

    let content_modal = null;

    const [openState, setModal] = useState(classes.WrapModalhide);
    const [isLoading, setIsLoading] = useState(false);

    const [addSmart, setAddSmart] = useState(null);
    const [removeSmart, setRemoveSmart] = useState(null);
    const [addGo, setAddGo] = useState(null);
    const [removeGo, setRemoveGo] = useState(null);

    const showSmart = planPermission === "10" || planPermission === "11";
    const showGo = planPermission === "01" || planPermission === "11";

    const netSmart = (addSmart || 0) - (removeSmart || 0);
    const netGo = (addGo || 0) - (removeGo || 0);

    const buildChangeSummary = () => {
        const parts = [];
        if (netSmart) {
            parts.push(`${netSmart > 0 ? "+" : ""}${netSmart} Smart`);
        }
        if (netGo) {
            parts.push(`${netGo > 0 ? "+" : ""}${netGo} Go`);
        }
        return parts.join(", ");
    };

    const sendUpdateJourney = () => {
        if (!netSmart && !netGo) {
            return message.warning("Insira um valor em um dos campos.");
        }

        const data = {
            companyUid,
        };
        if (netSmart) data.numberJourneysSmart = netSmart;
        if (netGo) data.numberUsersGo = netGo;

        const changeSummary = buildChangeSummary();

        setIsLoading(true);
        getCurrentUser().then(async (u) => {
            const session = await fetchAuthSession({
                forceRefresh: true
            });
            const userToken = session.tokens?.idToken?.toString()
            axios
                .put(ADMIN_AUDIOFOCO_ADD_JOURNEY, data, {
                    headers: {
                        Authorization:
                           userToken,
                    },
                })
                .then(() => {
                    setIsLoading(false);
                    onJourneyUpdated({ netSmart, netGo });
                    setShowModalAddJourney(false);
                    message.success(
                        `Alteração feita com sucesso: ${changeSummary}`
                    );
                })
                .catch((e) => {
                    console.log("e", e);
                    setIsLoading(false);
                    setShowModalAddJourney(false);
                    message.error(
                        "Não foi possível salvar a alteração. Tente novamente."
                    );
                });
        });
    };

    useEffect(() => {
        setModal(classes.WrapModal);
    }, []);

    content_modal = (
        <div className={openState} ref={myRefName}>
            <div className={classes.ContentModalAdd}>
                <div className={modalColor}>
                    <div className={classes.TopBar}>
                        <div
                            className={classes.CloseButtonX}
                            onClick={() => setShowModalAddJourney(false)}
                        >
                            X
                        </div>
                    </div>
                    <div className={classes.Information}>
                        <div className={classes.Title}>
                            {`Adicionar jornadas/Usuários (${companyUid})`}
                        </div>

                        {showSmart && (
                            <div className={classes.PlanSection}>
                                <div className={classes.PlanTitle}>Usuários Smart</div>
                                <div className={classes.PlanBlocks}>
                                    <div className={classes.PlanBlock}>
                                        <div className={classes.BlockLabel}>Adicionar</div>
                                        <div className={classes.BlockRow}>
                                            <InputNumber
                                                min={0}
                                                style={{ width: "100%" }}
                                                value={addSmart}
                                                disabled={isLoading || Boolean(removeSmart)}
                                                onChange={(value) => setAddSmart(value)}
                                            />
                                        </div>
                                        {Boolean(addSmart) && (
                                            <div className={classes.PreviewText}>
                                                {`Quantidade após adicionar: ${
                                                    currentUsersSmart + (addSmart || 0)
                                                }`}
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.PlanBlock}>
                                        <div className={classes.BlockLabel}>Remover</div>
                                        <div className={classes.BlockRow}>
                                            <InputNumber
                                                min={0}
                                                max={currentUsersSmart}
                                                style={{ width: "100%" }}
                                                value={removeSmart}
                                                disabled={isLoading || Boolean(addSmart)}
                                                onChange={(value) => setRemoveSmart(value)}
                                            />
                                        </div>
                                        {Boolean(removeSmart) && (
                                            <div className={classes.PreviewText}>
                                                {`Quantidade após remover: ${
                                                    currentUsersSmart - (removeSmart || 0)
                                                }`}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {showGo && (
                            <div className={classes.PlanSection}>
                                <div className={classes.PlanTitle}>Usuários Go</div>
                                <div className={classes.PlanBlocks}>
                                    <div className={classes.PlanBlock}>
                                        <div className={classes.BlockLabel}>Adicionar</div>
                                        <div className={classes.BlockRow}>
                                            <InputNumber
                                                min={0}
                                                style={{ width: "100%" }}
                                                value={addGo}
                                                disabled={isLoading || Boolean(removeGo)}
                                                onChange={(value) => setAddGo(value)}
                                            />
                                        </div>
                                        {Boolean(addGo) && (
                                            <div className={classes.PreviewText}>
                                                {`Quantidade após adicionar: ${
                                                    currentUsersGo + (addGo || 0)
                                                }`}
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.PlanBlock}>
                                        <div className={classes.BlockLabel}>Remover</div>
                                        <div className={classes.BlockRow}>
                                            <InputNumber
                                                min={0}
                                                max={currentUsersGo}
                                                style={{ width: "100%" }}
                                                value={removeGo}
                                                disabled={isLoading || Boolean(addGo)}
                                                onChange={(value) => setRemoveGo(value)}
                                            />
                                        </div>
                                        {Boolean(removeGo) && (
                                            <div className={classes.PreviewText}>
                                                {`Quantidade após remover: ${
                                                    currentUsersGo - (removeGo || 0)
                                                }`}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className={classes.SaveButtonRow}>
                            <Button
                                style={{ ...primaryButtonStyle, width: 140 }}
                                onMouseEnter={handlePrimaryButtonMouseEnter}
                                onMouseLeave={handlePrimaryButtonMouseLeave}
                                disabled={isLoading || (!netSmart && !netGo)}
                                onClick={sendUpdateJourney}
                            >
                                {isLoading ? "Salvando" : "Salvar"}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return <section>{content_modal}</section>;
};

export default ModalAddJourneys;
